<template>
  <v-row
    justify="center"
    align="center"
    class="ma-0 div-dias-semana fill-height"
  >
    <span class="text-datas-number">
      {{ qtLotesAlocadosConfirmados }}
    </span>
    <span class="text-datas-extenso ml-1 mr-1">de</span>
    <span class="text-datas-number">{{ filteredLots.length }}</span>
    <v-icon v-if="showCheckIcon" right small color="success">
      mdi-check-circle
    </v-icon>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "CardItemLoteAlocadoConfirmado",
  props: {
    itemData: {
      type: Object,
      default: {}
    },
    itemPlanta: {
      type: Object,
      default: {}
    }
  },
  computed: {
    ...mapState("programacaoAbate", [
      "listBatchsAllocated",
      "listCheckListAlocados",
      "programacaoAbateSelected"
    ]),
    itemCheckList() {
      let item = this.listCheckListAlocados.find(
        x =>
          x.cdProgramacaoAbateAlocado == this.itemLote.idProgramacaoAbateAlocado
      );
      if (item != undefined) {
        return item;
      }
      return { dtConfirmacaoProdutor: null };
    },
    filteredLots() {
      if (this.programacaoAbateSelected.cdStatusProgramacaoAbate >= 3) {
        if (!this.listBatchsAllocated) return [];
        return this.listBatchsAllocated.filter(x => {
          return (
            x.cdPlantaAbate === this.itemPlanta.cdPlantaAbate &&
            x.stDiaAlocado === this.itemData.value
          );
        });
      }
      return [];
    },
    qtLotesAlocadosConfirmados() {
      return this.filteredLots.reduce((acc, lot) => {
        const checklist = this.listCheckListAlocados.find(
          item =>
            item.cdProgramacaoAbateAlocado === lot.idProgramacaoAbateAlocado
        );
        if (checklist) acc += checklist.dtConfirmacaoProdutor ? 1 : 0;
        return acc;
      }, 0);
    },
    showCheckIcon() {
      return (
        this.qtLotesAlocadosConfirmados === this.filteredLots.length &&
        this.qtLotesAlocadosConfirmados !== 0
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
